export default __webpack_public_path__ + "static/media/maroon.84c8325c.png";